import React, { Component, Suspense } from 'react';
import './App.css';
import './MobileApp.css';
import './imagezoom.css';
import './SmStyle.css';
import './SmGeneral.css';
import './SmOverrideStyle.css';
import theme from './staymenu-theme';
import { Switch, Route, withRouter } from 'react-router-dom';
import { observer, inject } from 'mobx-react';
import { ThemeProvider } from '@material-ui/styles';
import { default as i18n } from './i18n';
import { Icon } from 'antd';
import { v4 } from 'uuid';
import MicRecorder from 'mic-recorder-to-mp3';
import PrivateRoute from './components/PrivateRoute';
import GuestRoute from './components/GuestRoute/GuestRouteComponent';

import { default as AdminLoginPage } from './admin/pages/Login/AdminLogin';
import { default as AdminDashboardPage } from './admin/pages/Dashboard';
// import { default as AdminItemPage } from './admin/pages/Item/AdminItem';
import { default as ChatIntentPage } from './admin/pages/ChatIntent/ChatIntent';
import { default as ImportChatIntentPage } from './admin/pages/ChatIntentImport/chatIntentImport';
import { default as OutOfStockPage } from './admin/pages/OutOfStock/OutOfStockPage';
import { default as BookingPage } from './admin/pages/Booking/BookingMain';
import { default as GuideDocumentPage } from './admin/pages/GuideDocument/GuideDocumentMain';
import { default as HotelFacilityPage } from './admin/pages/HotelFacility/HotelFacilityMain';
import { default as EventHotelPage } from './admin/pages/EventHotel/EventHotelMain';
import { default as SidebarPage } from './admin/pages/Sidebar/SidebarMain';
import { default as SpecialOfferPage } from './admin/pages/SpecialOffer/SpecialOffer';
import { default as RetailOfferPage } from './admin/pages/RetailOffer/RetailOffer';
import { default as SpaOfferPage } from './admin/pages/SpaOffer/SpaOffer';
import AdminHotelDescriptionPage from './admin/pages/HotelDescription/adminHotelDescription';
import { default as GeneralSettingPage } from './admin/pages/GeneralSetting/generalSetting';
import { default as OrderSetupPage } from './admin/pages/OrderSetup/ordersetuppage';
import FnbAdditionalItemPage from './admin/pages/FnbAdditionalItem/FnbAdditionalItem';
import ImportItemLanguagePage from './admin/pages/ImportItemLanguage/importItemLanguage';
import CmsLanguage from './admin/cms/CmsLanguage';
import CmsMenu from './admin/cms/CmsMenu';
import CmsTask from './admin/cms/CmsTask';
import WebSetting from './admin/cms/WebSetting';
import CmsPaymentType from './admin/cms/CmsPaymentType';
import CmsTransportationType from './admin/cms/CmsTransportationType';
import BookingItemPage from './admin/pages/BookingItem/BookingItem';
import BookingSubCategoryPage from './admin/pages/BookingSubCategory/BookingSubCategory';
import BookingCategoryPage from './admin/pages/BookingCategory/BookingCategory';
import BookingTransactionPage from './admin/pages/BookingTransaction/BookingTransaction';
import AuditLogPage from './admin/pages/AuditLog/AuditLog';
import { default as PopupPage } from './admin/pages/Popup/PopupMain';
import { default as TemplatePage } from './admin/pages/Template/TemplateMain';
import CmsLaundryDelivery from './admin/cms/CmsLaundryDelivery';
import CmsLaundryService from './admin/cms/CmsLaundryService';
import OutOfStockRecipientPage from './admin/pages/OutOfStockRecipient/OutOfStockRecipient';
import GuestLoginLogPage from './admin/pages/GuestLoginLog/GuestLoginLog';

import { default as DiningPage } from './admin/pages/Dining/DiningMain';
import { default as DevaranaPage } from './admin/pages/Devarana/DevaranaMain';
import { default as ExperiencePage } from './admin/pages/Experience/ExperienceMain';
import ItemRoomTypePage from './admin/pages/ItemRoomTypes/ItemRoomType';
import RoomSetupPage from './admin/pages/RoomSetups/RoomSetup';
import RoomTypePage from './admin/pages/RoomTypes/RoomType';
import AdminDailyActPage from './admin/pages/DailyAct/adminDailyAct';
import AdminDiveCenterPage from './admin/pages/DiveCenter/adminDiveCenter';
import PaymentLogPage from './admin/pages/PaymentLog/PaymentLog';

import SingleListMain from './modules/SingleList/SingleListMain';
import SingleListConfirm from './modules/SingleList/SingleListConfirm';
import AboutHotelPage from './pages/AboutHotel/aboutHotel';
import AmenityMainPage from './pages/Amenities/amenityMain';
import AmenityConfirmPage from './pages/Amenities/amenityConfim';
import BillingPage from './pages/Billing';
import BookingMainPage from './pages/Booking/bookingMain';
import BookTaxiPage from './pages/BookTaxi/BookTaxi';
import FnbMainPage from './pages/FnB/fnbMain';
import FnbConfirmPage from './pages/FnB/fnbConfirm';
import FnbSuccessPage from './pages/FnB/fnbSuccess';
import FnbFailedPage from './pages/FnB/fnbFailed';
import GuestLoginPage from './pages/GuestLogin/GuestLogin';
import GuestGuideDocumentPage from './pages/GuestGuideDocument/guestGuideDocument';
import HotelEventDetailPage from './pages/HotelEvent/HotelEvent';
import HotelFacilityDetailPage from './pages/HotelFacility/HotelFacility';
import CompendiumDetailPage from './pages/Compendium/Compendium';
import HotelReviewPage from './pages/HotelReview';
import HousekeepingOptInPage from './pages/HousekeepingOptIn/housekeepingOptIn';
import HousekeepingLinenChangePage from './pages/HousekeepingLinenChange/housekeepingLinenChange';
import LaundryMainPage from './pages/Laundry/laundryMain';
import LaundryConfirmPage from './pages/Laundry/laundryConfim';
import MasterHomePage from './pages/Master/masterHome';
import MasterChatPage from './pages/Master/masterChat';
import MasterOrderPage from './pages/Master/masterOrder';
import PrintFilePage from './pages/PrintFile/PrintFile';
import PrintFilePreviewPage from './pages/PrintFilePreview';
import RetailOfferClientPage from './pages/RetailOfferClient/RetailOfferClient';
import SpaOfferClientPage from './pages/SpaOfferClient/SpaOfferClient';
import ShoppingMainPage from './pages/Shopping/shoppingMain';
import ShoppingConfirmPage from './pages/Shopping/shoppingConfim';
import SpaMainPage from './pages/Spa/spaMain';
import SpaConfirmPage from './pages/Spa/spaConfirm';
import SpecialOfferClientPage from './pages/SpecialOfferClient/SpecialOfferClient';
import TvChannelPage from './pages/TvChannel/TvChannel';
import UploadTestPage from './pages/UploadTest';
import WakeUpCallPage from './pages/WakeUpCall/WakeUpCall';
import DiningDetailPage from './pages/Dining/Dining';
import DevaranaDetailPage from './pages/Devarana/Devarana';
import ExperienceDetailPage from './pages/Experience/Experience';
import DailyActPage from './pages/DailyAct/DailyActPage';
import DiveCenterPage from './pages/DiveCenter/DiveCenterPage';
import OrderPayResult from './pages/FnB/OrderPayResult';
// import SimpleLoadingScreen from './components/SimpleLoadingScreen';

const isDisableBot = process.env.REACT_APP_STAYCHAT_BOT_DISABLE !== "false";
const Mp3Recorder = new MicRecorder({ bitRate: 128 });

@inject('commonStore', 'translationStore', 'chatStore')
@withRouter
@observer
class App extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isRecording: false,
      isRecordingBlocked: false,
      recordButtonClass: '',
      recordButtonWidth: '80px',
      recordButtonHeight: '80px'
    }
  }

  componentDidMount() {
    this.props.commonStore.setHistory(this.props.history);

    const lang = this.props.translationStore.getLanguage();
    if (lang) {
      i18n.changeLanguage(lang);
    }

    this.initFab();
  }

  initFab = () => {
    const fabElement = document.getElementById("floating-snap-btn-wrapper");
    if (!fabElement) return;

    if (!isDisableBot) {
      navigator.mediaDevices.getUserMedia({ audio: true },
        () => {
          console.log('Mic Permission Granted');
          this.setState({ isBlocked: false });
        },
        () => {
          console.log('Mic Permission Denied');
          this.setState({ isBlocked: true });
        },
      );
    }

    const startRecording = () => {
      if (this.state.isRecordingBlocked) {
        console.log('Mic Permission Denied');
      } else {
        console.log("Recording started");

        this.setState({ recordButtonWidth: '100px' });
        this.setState({ recordButtonHeight: '100px' });
        this.setState({ recordButtonClass: 'blink-button' });

        Mp3Recorder
          .start()
          .then(() => {
            this.setState({ isRecording: true });
          }).catch((e) => console.error(e));
      }
    };

    const endRecording = () => {
      console.log("Recording ended");

      this.setState({ recordButtonWidth: '80px' });
      this.setState({ recordButtonHeight: '80px' });
      this.setState({ recordButtonClass: '' });

      Mp3Recorder
        .stop()
        .getMp3()
        .then(([buffer, blob]) => {
          if (!buffer || !blob?.size || blob.size < 5000) {
            console.log(`Audio size is too small (${blob?.size}), please try again.`);
            return;
          }

          const file = new File(buffer, `${v4()}.mp3`, {
            type: blob.type,
            lastModified: Date.now()
          });

          this.props.chatStore.sendVoice(file);
        }).catch((e) => console.log(e));
    };

    let oldPositionX, oldPositionY;

    const move = (e) => {
      if (!fabElement.classList.contains("fab-active")) {
        if (e.type === "touchmove") {
          fabElement.style.top = e.touches[0].clientY + "px";
          fabElement.style.left = e.touches[0].clientX + "px";
        } else {
          fabElement.style.top = e.clientY + "px";
          fabElement.style.left = e.clientX + "px";
        }
      }
    };

    const mouseDown = (e) => {
      e.preventDefault();
      console.log("mouse down");

      oldPositionY = fabElement.style.top;
      oldPositionX = fabElement.style.left;

      if (e.type === "mousedown") {
        window.addEventListener("mousemove", move);
      } else {
        window.addEventListener("touchmove", move);
      }

      fabElement.style.transition = "none";

      startRecording();
    };

    const mouseUp = (e) => {
      e.preventDefault();
      console.log("mouse up");

      if (e.type === "mouseup") {
        window.removeEventListener("mousemove", move);
      } else {
        window.removeEventListener("touchmove", move);
      }

      snapToSide(e);
      fabElement.style.transition = "0.3s ease-in-out left";

      endRecording();
    };

    const snapToSide = (e) => {
      const wrapperElement = document.getElementById('main-wrapper');
      const windowWidth = window.innerWidth;
      let currPositionX, currPositionY;
      if (e.type === "touchend") {
        currPositionX = e.changedTouches[0].clientX;
        currPositionY = e.changedTouches[0].clientY;
      } else {
        currPositionX = e.clientX;
        currPositionY = e.clientY;
      }
      if (currPositionY < 50) {
        fabElement.style.top = 50 + "px";
      }
      if (currPositionY > wrapperElement.clientHeight - 50) {
        fabElement.style.top = (wrapperElement.clientHeight - 50) + "px";
      }
      if (currPositionX < windowWidth / 2) {
        fabElement.style.left = 50 + "px";
        fabElement.classList.remove('right');
        fabElement.classList.add('left');
      } else {
        fabElement.style.left = windowWidth - 50 + "px";
        fabElement.classList.remove('left');
        fabElement.classList.add('right');
      }
    };

    fabElement.addEventListener("mousedown", mouseDown);

    fabElement.addEventListener("mouseup", mouseUp);

    fabElement.addEventListener("touchstart", mouseDown);

    fabElement.addEventListener("touchend", mouseUp);

    fabElement.addEventListener("click", (e) => {
      if (
        oldPositionY === fabElement.style.top &&
        oldPositionX === fabElement.style.left
      ) {
        fabElement.classList.toggle("fab-active");
      }
    });
  }

  render() {
    let isDisableBotButton = isDisableBot || window.location.pathname.includes("login") || window.location.pathname.includes("admin");

    return (
      <ThemeProvider theme={theme}>
        <Suspense fallback={null}>
          <div id="main-wrapper" style={isDisableBotButton ? { overflow: 'auto' } : { overflow: 'hidden' }}>
            <Switch>
              <Route path='/login/:roomNumber?/:lastName?' component={GuestLoginPage} />
              <Route path='/print-preview/:printCode' component={PrintFilePreviewPage} />
              <Route path='/home' component={MasterHomePage} />
              <Route path='/chat' component={MasterChatPage} />
              <Route path='/order' component={MasterOrderPage} />
              <Route path='/single-list/:menuID?/language/:languageID?' component={SingleListMain} />
              <Route path='/single-list-confirm/:menuID?/language/:languageID?/item/:itemID?' component={SingleListConfirm} />
              <Route path='/amenity' component={AmenityMainPage} />
              <Route path='/amenity-confirm' component={AmenityConfirmPage} />
              <Route path='/booking' component={BookingMainPage} />
              <Route path='/wakeup-call' component={WakeUpCallPage} />
              <Route path='/transportation' component={BookTaxiPage} />
              <Route path='/tv-channel' component={TvChannelPage} />
              <Route path='/laundry' component={LaundryMainPage} />
              <Route path='/laundry-confirm' component={LaundryConfirmPage} />
              <Route path='/shopping' component={ShoppingMainPage} />
              <Route path='/shopping-confirm' component={ShoppingConfirmPage} />
              <Route path='/fnb/:taskId?' component={FnbMainPage} />
              <Route path='/fnb-confirm' component={FnbConfirmPage} />
              <Route path='/fnb-success' component={FnbSuccessPage} />
              <Route path='/fnb-failed' component={FnbFailedPage} />
              <Route path='/spa/:taskId?' component={SpaMainPage} />
              <Route path='/spa-confirm' component={SpaConfirmPage} />
              {/* <Route path='/about-hotel' component={AboutHotelPage} /> */}
              <Route path='/billing' component={BillingPage} />
              <Route path='/hotel-review' component={HotelReviewPage} />
              <Route path='/housekeeping-optin' component={HousekeepingOptInPage} />
              <Route path='/housekeeping-linenchange' component={HousekeepingLinenChangePage} />
              <Route path='/upload-test' component={UploadTestPage} />
              <Route path='/print-file' component={PrintFilePage} />
              <Route path='/special-offer/:id' component={SpecialOfferClientPage} />
              <Route path='/retail-offer/:id' component={RetailOfferClientPage} />
              <Route path='/spa-offer/:id' component={SpaOfferClientPage} />
              <Route path='/event/:id' component={HotelEventDetailPage} />
              <Route path='/compendium/:id' component={CompendiumDetailPage} />
              <Route path='/facility/:id' component={HotelFacilityDetailPage} />
              <Route path='/guestguidedocument' component={GuestGuideDocumentPage} />
              <Route path='/dining/:id' component={DiningDetailPage} />
              <Route path='/devarana/:id' component={DevaranaDetailPage} />
              <Route path='/experience/:id' component={ExperienceDetailPage} />
              <Route path='/daily-act' component={DailyActPage} />
              <Route path='/dive-center' component={DiveCenterPage} />
              <Route path='/PaySuccess' component={OrderPayResult} />

              <Route path='/admin/login/:token?' component={AdminLoginPage} />
              <PrivateRoute path='/admin/dashboard' component={AdminDashboardPage} />
              <PrivateRoute path='/admin/chat-intent' component={ChatIntentPage} />
              <PrivateRoute path='/admin/chat-intent-import' component={ImportChatIntentPage} />
              {/* <PrivateRoute path='/admin/item' component={AdminItemPage} /> */}
              <PrivateRoute path='/admin/outofstock' component={OutOfStockPage} />
              <PrivateRoute path='/admin/booking' component={BookingPage} />
              <PrivateRoute path='/admin/recommendation' component={OrderSetupPage} />
              <PrivateRoute path='/admin/guidedocument' component={GuideDocumentPage} />
              <PrivateRoute path='/admin/hotelfacility' component={HotelFacilityPage} />
              <PrivateRoute path='/admin/eventhotel' component={EventHotelPage} />
              <PrivateRoute path='/admin/compendium' component={SidebarPage} />
              <PrivateRoute path='/admin/fnboffer' component={SpecialOfferPage} />
              <PrivateRoute path='/admin/retailoffer' component={RetailOfferPage} />
              <PrivateRoute path='/admin/spaoffer' component={SpaOfferPage} />
              {/* <PrivateRoute path='/admin/hoteldescription' component={AdminHotelDescriptionPage} /> */}
              <PrivateRoute path='/admin/fnb-additional-item' component={FnbAdditionalItemPage} />
              <PrivateRoute path='/admin/generalsetting' component={GeneralSettingPage} />
              <PrivateRoute path='/admin/import-items' component={ImportItemLanguagePage} />
              <PrivateRoute path='/admin/cms-language' component={CmsLanguage} />
              <PrivateRoute path='/admin/cms-menu' component={CmsMenu} />
              <PrivateRoute path='/admin/item' component={CmsTask} />
              <PrivateRoute path='/admin/web-setting' component={WebSetting} />
              <PrivateRoute path='/admin/cms-transportation-type' component={CmsTransportationType} />
              <PrivateRoute path='/admin/booking-item' component={BookingItemPage} />
              <PrivateRoute path='/admin/booking-sub-category' component={BookingSubCategoryPage} />
              <PrivateRoute path='/admin/booking-category' component={BookingCategoryPage} />
              <PrivateRoute path='/admin/booking-transaction' component={BookingTransactionPage} />
              <PrivateRoute path='/admin/audit-log' component={AuditLogPage} />
              <PrivateRoute path='/admin/popup' component={PopupPage} />
              <PrivateRoute path='/admin/template' component={TemplatePage} />
              <PrivateRoute path='/admin/laundry-delivery' component={CmsLaundryDelivery} />
              <PrivateRoute path='/admin/laundry-service' component={CmsLaundryService} />
              <PrivateRoute path='/admin/outofstockrecipient' component={OutOfStockRecipientPage} />
              <PrivateRoute path='/admin/cms-payment-type' component={CmsPaymentType} />
              <PrivateRoute path='/admin/guest-login-log' component={GuestLoginLogPage} />
              <PrivateRoute path='/admin/dining' component={DiningPage} />
              <PrivateRoute path='/admin/devarana' component={DevaranaPage} />
              <PrivateRoute path='/admin/experience' component={ExperiencePage} />
              <PrivateRoute path='/admin/item-room-type' component={ItemRoomTypePage} />
              <PrivateRoute path='/admin/room-setup' component={RoomSetupPage} />
              <PrivateRoute path='/admin/room-type' component={RoomTypePage} />
              <PrivateRoute path='/admin/daily-act' component={AdminDailyActPage} />
              <PrivateRoute path='/admin/dive-center' component={AdminDiveCenterPage} />
              <PrivateRoute path='/admin/payment-history' component={PaymentLogPage} />

              <GuestRoute path='/' component={MasterHomePage} />
            </Switch>

            {
              <div id="floating-snap-btn-wrapper" style={isDisableBotButton ? { display: 'none' } : {}}>
                <div className="fab-btn" style={{ width: this.state.recordButtonWidth, height: this.state.recordButtonHeight }}>
                  <Icon type="robot" />
                </div>
                {/* <ul>
                  <li>
                    BOT
                  </li>
                  <li>
                    BOT
                  </li>
                </ul> */}
              </div>
            }
          </div>
        </Suspense>
      </ThemeProvider>
    )
  }
}

export default App;
